import { Storage } from '@ionic/storage';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { TokenResponseModel } from '../models/auth.model';
import { shcAccessToken } from '../constants/general.constant';
import {
  distinctUntilChanged,
  first,
  map,
  publishReplay,
  refCount,
} from 'rxjs/operators';

@Injectable()
export class TokenStoreService {
  private readonly tokenObservable: Observable<TokenResponseModel>;

  private tokenSubject: ReplaySubject<TokenResponseModel> = new ReplaySubject(
    1,
  );

  constructor(private storage: Storage) {
    const initStorage = storage.create();
    const initTimeout = new Promise<void>((resolve) => {
      setTimeout(() => resolve(), 5000);
    });

    Promise.race([initStorage, initTimeout])
      .then(() => storage.get(shcAccessToken))
      .catch(() => null)
      .then((token) => {
        this.tokenSubject.next(token || null);
      });

    this.tokenObservable = this.tokenSubject.pipe(
      distinctUntilChanged(),
      publishReplay(1),
      refCount(),
    );
  }

  get loggedIn() {
    return this.onLoginChange.pipe(first());
  }

  get onLoginChange() {
    return this.onTokenChange.pipe(
      map((token) => {
        return !!token;
      }),
    );
  }

  get onTokenChange() {
    return this.tokenObservable;
  }

  get token() {
    return this.onTokenChange.pipe(first());
  }

  updateToken(value?: TokenResponseModel) {
    let promise: Promise<any>;

    if (value) {
      promise = this.storage.set(shcAccessToken, value);
    } else {
      promise = this.storage.remove(shcAccessToken).catch(() => null);
    }

    return promise.then(() => {
      this.tokenSubject.next(value);

      return value;
    });
  }
}
